import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FaArrowRight, FaChevronDown, FaChevronRight } from 'react-icons/fa';

const FAQsRow = () => {
    const [loading, setLoading] = useState(true);
    const [faqs, setFaqs] = useState([]);
    const [expandedId, setExpandedId] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/faq/items/featured?limit=6`)
            .then(res => {
                if (res.data.success) setFaqs(res.data.faqs || []);
            })
            .finally(() => setLoading(false));
    }, []);

    const toggleExpand = (id) => {
        setExpandedId(prev => prev === id ? null : id);
    };

    if (loading || faqs.length === 0) return null;

    return (
        <section className="faqsHomeSection">
            <section className="mainSection">
                <div className="scrollable-row">
                    <div className="heading-container">
                        <h2>Frequently Asked Questions</h2>
                    </div>
                </div>
                <div className="faqsHomeAccordion">
                    {faqs.slice(0, 6).map(item => (
                        <div
                            key={item._id}
                            className={`faqHomeItem ${expandedId === item._id ? 'expanded' : ''}`}
                        >
                            <button
                                type="button"
                                className="faqHomeItemBtn"
                                onClick={() => toggleExpand(item._id)}
                                aria-expanded={expandedId === item._id}
                            >
                                <span className="faqHomeItemQ">{item.question}</span>
                                <span className="faqHomeItemIcon">{expandedId === item._id ? <FaChevronDown /> : <FaChevronRight />}</span>
                            </button>
                            <div className="faqHomeItemContent">
                                <div className="faqHomeItemAnswer" dangerouslySetInnerHTML={{ __html: item.answer }} />
                            </div>
                        </div>
                    ))}
                </div>
                <div className="faqsHomeFooter">
                    <Link to="/faq" className="seeAllBtn">
                        View All FAQs <FaArrowRight />
                    </Link>
                </div>
            </section>
        </section>
    );
};

export default FAQsRow;
